module.exports = __webpack_public_path__ + "static/media/efrs_loading.76309bf7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/efrs_loading.svg
// module id = 292
// module chunks = 33